import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPMaltaCertificateData } from "@/src/types/admissionOffice";
import type { CertificateBasicCountry } from "./certificateBasicRegistry";

const emptyCertificateState = (): AOPMaltaCertificateData => ({
  currentDate: "",
  fullName: "",
  body: [],
  userOffice: "01",
  whose_doc: "",
});

export interface AOPCertificateBasicLayoutProps {
  country: CertificateBasicCountry;
}

const AOPCertificateBasicLayout = ({ country }: AOPCertificateBasicLayoutProps) => {
  const [certificateInfo, setCertificateInfo] = useState<string>("");
  const [dataForGeneration, setDataForGeneration] = useState<AOPMaltaCertificateData>(emptyCertificateState);
  const [bodyForPrev, setBodyForPrev] = useState<AOPMaltaCertificateData>(emptyCertificateState);

  return (
    <div className="container admission-office-page">
      <AOPConfig
        country={country}
        dataForGeneration={dataForGeneration}
        setDataForGeneration={setDataForGeneration}
        setBodyForPrev={setBodyForPrev}
        setCertificateInfo={setCertificateInfo}
      />
      <AOPPrev country={country} bodyForPrev={bodyForPrev} certificateInfo={certificateInfo} />
    </div>
  );
};

export default AOPCertificateBasicLayout;
